import React, { useRef } from 'react';
import VideoCard from './VideoCard';
import PromotedCard from './PromotedCard';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function CategoryRow({ title, videos, moreHref, category }) {
  const ref = useRef(null);
  const scroll = (dir) => {
    const el = ref.current; if (!el) return;
    el.scrollBy({ left: dir * (el.clientWidth * 0.85), behavior: 'smooth' });
  };

  return (
    <section className="mb-10">
      <div className="row-head">
        <h2 className="row-title text-white">{title}</h2>
        <div className="flex items-center gap-2">
          {moreHref && <Link to={moreHref} className="text-[13px] text-white/60 hover:text-[#ff6b8a]">See all</Link>}
          <button onClick={() => scroll(-1)} className="w-8 h-8 rounded-full bg-white/[0.05] border border-white/10 grid place-items-center hover:bg-white/10" aria-label="Scroll left">
            <ChevronLeft className="w-4 h-4" />
          </button>
          <button onClick={() => scroll(1)} className="w-8 h-8 rounded-full bg-white/[0.05] border border-white/10 grid place-items-center hover:bg-white/10" aria-label="Scroll right">
            <ChevronRight className="w-4 h-4" />
          </button>
        </div>
      </div>
      <div ref={ref} className="flex gap-4 overflow-x-auto scroll-x pb-2 snap-x">
        {videos.map((v, i) => (
          <React.Fragment key={v.id}>
            <div className="w-[260px] md:w-[300px] shrink-0 snap-start">
              <VideoCard video={v} />
            </div>
            {i === 2 && category && (
              <div className="w-[260px] md:w-[300px] shrink-0 snap-start">
                <PromotedCard category={category} />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
}

